/* LUKE 20260819 v4 — SAFE swipe->color sync, timing-robust.
   Detects the gallery image currently in view (IntersectionObserver + document-capture
   scroll/touch), maps alt->color, and if it differs from the checked color, CLICKS that
   color's label (drives the correct Dawn chain -> button AND cart both follow). Loop-guarded. */
(function(){
  if (window.__bbqGalleryColorSyncSafe20260819) return;
  window.__bbqGalleryColorSyncSafe20260819 = true;
  function norm(s){ return (s||'').toLowerCase().replace(/&/g,'and').replace(/[^a-z0-9]+/g,' ').trim(); }
  function colorFieldset(){
    return Array.prototype.slice.call(document.querySelectorAll('variant-selects fieldset, fieldset.product-form__input, .product-form__input')).find(function(fs){
      var l=fs.querySelector('legend,.form__label'); return /color/i.test((l&&l.textContent)||'');
    });
  }
  function colorInputs(){ var fs=colorFieldset(); return fs?Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]')):[]; }
  function checkedColor(){ var r=colorInputs().find(function(i){return i.checked;}); return r&&r.value; }
  function colorFromAlt(alt){
    alt=(alt||'').trim(); if(!alt) return null;
    var vals=colorInputs().map(function(i){return i.value;}).sort(function(a,b){return b.length-a.length;});
    var suffix = alt.indexOf(' - ')>-1 ? alt.split(' - ').pop().trim() : alt;
    var v=vals.find(function(x){return norm(suffix)===norm(x);}); if(v) return v;
    return vals.find(function(x){return norm(alt).indexOf(norm(x))>-1;}) || null;
  }
  function galleryBox(){
    var g=document.querySelector('media-gallery, [id^="MediaGallery"], .product__media-wrapper, .product__media-list');
    return g ? g.getBoundingClientRect() : null;
  }
  function mainImgs(){
    return Array.prototype.slice.call(document.querySelectorAll('media-gallery img[alt], .product__media-item img[alt], .product__media-list img[alt], .product__media img[alt]'))
      .filter(function(im){ var r=im.getBoundingClientRect(); return r.width>60 && r.height>60; });
  }
  function centeredImg(){
    var gb=galleryBox(); if(!gb) return null; var gc=gb.left+gb.width/2, best=null, bd=1e9;
    mainImgs().forEach(function(im){
      var r=im.getBoundingClientRect();
      if(r.right<gb.left-5||r.left>gb.right+5) return;         // must overlap the gallery viewport
      var d=Math.abs((r.left+r.width/2)-gc); if(d<bd){bd=d;best=im;}
    });
    return best;
  }
  var busy=false, t=null;
  function setColorState(input, color){
    // Carousel->color is a visual/variant-state synchronization, not a request
    // to re-render product-info. A label click dispatches Dawn's change handler,
    // fetches the whole section, and briefly removes/rebuilds the Size Chart.
    input.checked=true;
    input.setAttribute('checked','checked');
    colorInputs().forEach(function(i){ if(i!==input) i.removeAttribute('checked'); });
    var fs=colorFieldset();
    var selected=fs&&fs.querySelector('[data-selected-value], .selected-option-value');
    if(selected) selected.textContent=color;

    var sizeFs=Array.prototype.slice.call(document.querySelectorAll('variant-selects fieldset, fieldset.product-form__input')).find(function(f){
      var l=f.querySelector('legend,.form__label'); return /size/i.test((l&&l.textContent)||'');
    });
    var size=sizeFs&&sizeFs.querySelector('input[type="radio"]:checked');
    var map=document.querySelector('script[id^="VariantMap-"]');
    var variants=[];
    try { variants=map?JSON.parse(map.textContent||'[]'):[]; } catch(e) {}
    var variant=variants.find(function(v){ return norm(v.option1)===norm(color) && (!size || norm(v.option2)===norm(size.value)); });
    if(variant){
      document.querySelectorAll('form[action*="/cart/add"] input[name="id"], product-form input[name="id"]').forEach(function(i){ i.value=String(variant.id); });
      var add=document.querySelector('button[name="add"], .product-form__submit');
      if(add){ add.disabled=!variant.available; add.toggleAttribute('aria-disabled',!variant.available); }
      try { history.replaceState(history.state,'',location.pathname+'?variant='+variant.id); } catch(e) {}
    }
  }
  function sync(){
    if(busy) return;
    var img=centeredImg(); if(!img) return;
    var color=colorFromAlt(img.getAttribute('alt')); if(!color) return;
    if(norm(color)===norm(checkedColor())) return;             // matches -> no loop
    var input=colorInputs().find(function(i){return norm(i.value)===norm(color);});
    if(!input || input.checked) return;
    busy=true;
    setColorState(input,color);
    setTimeout(function(){ busy=false; sync(); }, 650);         // re-check after settle
  }
  function schedule(){ clearTimeout(t); t=setTimeout(sync, 130); }
  // Robust triggers — independent of when the gallery loads:
  document.addEventListener('scroll', schedule, true);          // capture catches inner scroll containers
  document.addEventListener('slideChanged', schedule, true);
  document.addEventListener('touchend', schedule, true);
  window.addEventListener('load', schedule);
  // IntersectionObserver backstop: fire when a slide becomes majority-visible (the one swiped to)
  var io=null, seen=new WeakSet(), tries=0;
  function wire(){
    var imgs=mainImgs();
    if(imgs.length){
      if(!io) io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting && e.intersectionRatio>=0.55) schedule(); }); }, {threshold:[0.55,0.8]});
      imgs.forEach(function(im){ if(!seen.has(im)){ seen.add(im); io.observe(im); } });
    }
    if(++tries<60) setTimeout(wire, 400);                       // keep wiring as gallery hydrates
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', wire); else wire();
  // POLL fallback: real-device swipes may not fire scroll/IO reliably; check centered slide periodically.
  var lastPolled=null;
  setInterval(function(){ try{ var im=centeredImg(); var a=im&&im.getAttribute('alt'); if(a && a!==lastPolled){ lastPolled=a; schedule(); } }catch(e){} }, 400);
})();
